import { HorizontalShelf } from "./HorizontalShelf";
import { Sticker } from "@wags/ui/sticker.tsx";

export type PopularBreed = { id: string; name: string };

const TILTS = [-3, 2.5, -2, 3, -1.5, 2, -2.5, 1.5, -3, 2, -2, 2.5];

export function BreedCarousel({
    breeds,
    onSelect,
    onSearchAll,
}: {
    breeds: PopularBreed[];
    onSelect: (breedId: string) => void;

    onSearchAll?: () => void;
}) {
    if (breeds.length === 0) return null;
    return (
        <div className="flex w-full flex-col gap-2">
            {/* oxlint-disable-next-line shadcn/no-arbitrary-values -- 13.5px falls between text-body-small (13px) and text-body (15px) */}
            <p className="font-family-body text-[13.5px] font-medium text-doberman-black/70">
                Or by breed
            </p>

            <HorizontalShelf>
                {breeds.map((b, i) => (
                    <StickerButton
                        key={b.id}
                        text={b.name}
                        rotation={TILTS[i % TILTS.length]}
                        onClick={() => onSelect(b.id)}
                    />
                ))}
                {onSearchAll && (
                    <StickerButton
                        text="Don't see yours?"
                        outlineColor="var(--color-labrador-yellow, #FFBA47)"

                        outlineWidth={4}
                        rotation={-2}
                        onClick={onSearchAll}
                    />
                )}
            </HorizontalShelf>
        </div>
    );
}

function StickerButton({
    text,
    rotation,
    onClick,
    outlineColor,
    outlineWidth = 2.5,
}: {
    text: string;
    rotation: number;
    onClick: () => void;
    outlineColor?: string;
    outlineWidth?: number;
}) {
    return (
        <button
            type="button"
            aria-label={text}
            onClick={onClick}
            className="shrink-0 snap-start rounded-nested px-3 py-2 outline-none transition-transform duration-150 ease-out-quint hover:scale-106 active:scale-96 focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-true-white motion-reduce:transition-none"
        >
            <Sticker
                text={text}
                outlineColor={outlineColor}
                outlineWidth={outlineWidth}
                fontSize={24}
                rotation={rotation}
            />
        </button>
    );
}
